import React, { Component } from 'react';
import './styles/VersionSelection.css';
import { Cookies } from 'react-cookie';

class VersionSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      version: '',
    };
  }

  onVersionSelect = (event) => {
    if (event && event.target) {
      this.setState({
        version: event.target.value,
      });
    }
  };

  onContinue = () => {
    if (this.state.version === 'us') {
      window.location.href = 'https://us.korucalculator.com/';
    } else {
      const cookies = new Cookies();
      const futureDate = new Date();
      futureDate.setFullYear(futureDate.getFullYear() + 10);
      cookies.set('version', this.state.version, {
        expires: futureDate,
      });
      this.props.setVersion(this.state.version);
    }
  };

  render() {
    return (
      <div className="version-title-ctr">
        <h3>Select Calculator Version</h3>
        <select
          className="version-select"
          onChange={this.onVersionSelect}
        >
          <option value="">Select Version...</option>
          <option value="us">US Version</option>
          <option value="international">International Version</option>
        </select>
        <div>
          <button
            disabled={!this.state.version}
            onClick={this.onContinue}
            className="version-continue-button"
          >
            Continue
          </button>
        </div>
        <div className="row">
          <div className="col-lg-6 offset-lg-3 col-xs-12 mt-5 reference-hdr">
            <p>
              The calculator is intended for reference only. Always
              refer to the Instructions for Use for the infusion
              system and the{' '}
              {this.state.version !== 'us'
                ? 'medicinal product'
                : 'drug'}
              /biologic prescribing information (PI) prior to using
              the device.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default VersionSelection;



// WEBPACK FOOTER //
// ./src/VersionSelection.js